// src/components/loaders/index.jsx
import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Loader para páginas completas
export const PageLoader = ({ message = "Cargando..." }) => {
  return (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      <span className="ml-3 text-gray-700">{message}</span>
    </div>
  );
};

// Loader con backdrop para acciones (basado en Material UI)
export const ActionLoader = ({ open, onClose = () => {} }) => {
  return (
    <Backdrop
      sx={(theme) => ({ 
        color: '#fff', 
        zIndex: theme.zIndex.drawer + 1 
      })}
      open={open}
      onClick={onClose}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

// Versión Tailwind del ActionLoader (si prefieres no usar Material UI)
export const TailwindActionLoader = ({ open }) => {
  if (!open) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
    </div>
  );
};

export const ErrorPage = ({ message = "Ocurrió un error inesperado.", onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center">
      <div className="text-red-500 text-4xl mb-2">⚠️</div>
      <h2 className="text-xl font-semibold mb-2">¡Algo salió mal!</h2>
      <p className="text-gray-700 mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          Reintentar
        </button>
      )}
    </div>
  );
};